import z from "zod";

export const MIN_PASSWORD_LENGTH = 10;

export function containsUppercase(ch: string) {
  return /[A-Z]/.test(ch);
}

export function containsLowercase(ch: string) {
  return /[a-z]/.test(ch);
}

export function containsSpecialChar(ch: string) {
  // eslint-disable-next-line no-useless-escape
  return /[`!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?~ ]/.test(ch);
}

export function containsNumber(ch: string) {
  return /[0-9]/.test(ch);
}

export function isPasswordValid(str: string) {
  return (
    containsUppercase(str) &&
    containsLowercase(str) &&
    containsSpecialChar(str) &&
    containsNumber(str) &&
    str.length >= MIN_PASSWORD_LENGTH
  );
}

export function capitalizeWords(str?: string | null): string {
  if (!str) {
    return "";
  }

  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function getStringAcronym(str?: string | null, length: number = 2): string {
  if (!str) {
    return "";
  }

  return str
    .split(/\s/)
    .slice(0, length)
    .reduce<string>((prev, curr) => (prev += curr.slice(0, 1)), "");
}

export const stringBoolSchema = z.enum(["true", "false"]).transform((v) => v === "true");
